<template>
  <div class="pt-4 border-t border-gray-200">
    <h4 class="text-sm font-medium text-gray-900 mb-3">Device Information</h4>
    <div class="grid grid-cols-2 gap-4 text-sm">
      <div>
        <span class="text-gray-500">IP Address:</span>
        <div class="font-medium">{{ device.network?.ipAddress || 'Unknown' }}</div>
      </div>
      <div>
        <span class="text-gray-500">Signal:</span>
        <div class="font-medium">{{ device.network?.signalStrength || 'Unknown' }} dBm</div>
      </div>
      <div>
        <span class="text-gray-500">Memory:</span>
        <div class="font-medium">{{ formatMemory(device.shadow?.reported?.memoryUsage) }}</div>
      </div>
      <div>
        <span class="text-gray-500">Uptime:</span>
        <div class="font-medium">{{ formatUptime(device.shadow?.reported?.timestamp) }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  device: {
    type: Object,
    required: true
  }
})

const formatMemory = (memoryUsage) => {
  if (!memoryUsage) return 'Unknown'
  return `${memoryUsage.toFixed(1)} KB`
}

const formatUptime = (timestamp) => {
  if (!timestamp) return 'Unknown'
  const uptimeMs = timestamp
  const uptimeHours = Math.floor(uptimeMs / (1000 * 60 * 60))
  return `${uptimeHours}h`
}
</script>